import { Button, Container, Grid, Typography } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import TripengerTheme from '~/styles/theme';
import { useAppSelector } from '~/modules/hooks';
import { selectUser } from '~/selectors';
import Header from '~/components/Header';
import Footer from '~/components/Footer';

interface Props {
  error: Error;
  resetErrorBoundary: () => void;
}

export default function ErrorHandler({ error, resetErrorBoundary }: Props) {
  const user = useAppSelector(selectUser);
  const { isAuthenticated } = user;

  const handleClickReset = () => {
    resetErrorBoundary();
  };

  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <ThemeProvider theme={TripengerTheme}>
      <Grid container direction="column" sx={{ minHeight: '90vh', backgroundColor: '#f5f5f5' }}>
        <Grid item>
          <Header isAuthenticated={isAuthenticated} />
        </Grid>

        <Grid item flex={1}>
          <Container maxWidth="md" sx={{ py: 8, textAlign: 'center' }}>
            <Typography variant="h4" gutterBottom>
              Oops! Something went wrong.
            </Typography>
            <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
              {error.message}
            </Typography>
            <Button variant="contained" color='secondary' onClick={handleGoHome}>
              Go to Homepage
            </Button>
            <Button variant="contained" color="primary" onClick={handleClickReset} sx={{ ml: 2 }}>
              Try Again
            </Button>
          </Container>
        </Grid>

        <Grid item>
          <Footer />
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
